import { ComposeContextProps } from './interface'

export const ComposeProvider = ({
    with: Providers,
    children
}: ComposeContextProps) => {
    return (
        <>
            {Providers.reduce(
                (AccProviders, Provider) => (
                    <Provider>{AccProviders}</Provider>
                ),
                children
            )}
        </>
    )
}
